// ─────────────────────────────────────────
//  CODE & EDITOR
// ─────────────────────────────────────────

import { S, sb } from './state.js';
import { showToast, trackSignal } from './utils.js';
import { hideSteps } from './ui.js';

export function applyCode(code) {
  S.code = code;
  document.getElementById('code-editor').value = code;
  updateStats();
}

export function onCodeChange() {
  S.code = document.getElementById('code-editor').value;
  updateStats();
}

export function updateStats() {
  const lines = S.code ? S.code.split('\n').length : 0;
  document.getElementById('line-count').textContent = lines + ' line' + (lines !== 1 ? 's' : '');
  document.getElementById('char-count').textContent = S.code.length + ' chars';
}

export function notifyCodeUpdate() {
  if (S.view !== 'code') document.getElementById('code-badge')?.classList.add('show');
  if (S.view !== 'preview') document.getElementById('preview-badge')?.classList.add('show');
}

export function clearChat() {
  // Track clear signal
  if (S.code && S.history.length > 0) trackSignal('clear');

  // Reset state immediately
  S.history = [];
  S.code = '';
  S.projectId = null;
  S.localProjectId = null;
  S.convId = null;

  // Clear code editor
  document.getElementById('code-editor').value = '';
  updateStats();

  // Clear preview
  const iframe = document.getElementById('preview-iframe');
  if (iframe) iframe.srcdoc = '';
  const urlEl = document.getElementById('preview-url');
  if (urlEl) urlEl.textContent = 'No preview yet — describe something and hit Run';

  // Clear agent steps
  hideSteps();

  // Reset messages to empty state (gallery is now in /studio)
  const msgs = document.getElementById('messages');
  if (msgs) msgs.innerHTML = '<div class="msg assistant" id="welcome-msg"><div class="msg-label">KasiCode AI</div><div class="msg-bubble">Chat cleared. Describe any changes you want to make, or go to <a href="/studio" style="color:var(--accent);">Studio</a> to start a new build.</div></div>';

  showToast('✓ Cleared');

  // Deactivate conversation in Supabase (fire and forget)
  if (S.session) {
    sb.from('conversations')
      .update({ is_active: false })
      .eq('user_id', S.session.user.id)
      .eq('is_active', true)
      .then(() => {})
      .catch(() => {});
  }
}
